import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function MyOrderds() {
  let server_url = localStorage.getItem("server_url");
  let dealer_id = localStorage.getItem("dealer_id");
  const [orderds, setOrderds] = useState([]);
  const dealer_price_set = localStorage.getItem("dealer_price_set_new");
  let token = localStorage.getItem("token");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const today = new Date().toISOString().split("T")[0]; // Today's date (YYYY-MM-DD)
  // Calculate date 30 days ago
  const pastDate = new Date();
  pastDate.setDate(pastDate.getDate() - 30);
  const last30Days = pastDate.toISOString().split("T")[0]; // Last 30 days date (YYYY-MM-DD)
  const [from, setFrom] = useState(last30Days);
  const [to, setTo] = useState(today);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    get_orderds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, to]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    check_user();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const check_user = async () => {
    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer_id);
    formData.append("device_token", token);

    await axios
      .post(`${server_url}check_dealer.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((result) => {
        if (result.data.status === "1") {
          localStorage.setItem(
            "LoginNumber",
            result.data.result[0].dealer_login_mobile,
          );
          localStorage.setItem(
            "notificaion_count",
            result.data.result[0].dealer_notification_count,
          );
          localStorage.setItem(
            "local_overdue_amount",
            result.data.result[0].overdue_amount,
          );
          localStorage.setItem(
            "local_dealer_os",
            result.data.result[0].dealer_os,
          );
          localStorage.setItem("order_date", result.data.result[0].order_date);
          localStorage.setItem(
            "local_items_in_cart",
            result.data.result[0].items_in_cart,
          );
          localStorage.setItem(
            "local_current_order_status",
            result.data.result[0].current_order_status,
          );
          localStorage.setItem(
            "local_order_final_total_with_gst",
            result.data.result[0].order_final_total_with_gst,
          );
          localStorage.setItem(
            "local_order_id",
            result.data.result[0].order_id,
          );
          localStorage.setItem(
            "admin_message",
            result.data.result[0].admin_message,
          );
          localStorage.setItem(
            "local_dealer_firm_name",
            result.data.result[0].dealer_firm_name,
          );
          localStorage.setItem("dealer_id", result.data.result[0].dealer_id);
          localStorage.setItem(
            "dealer_firm_name",
            result.data.result[0].dealer_firm_name,
          );
          localStorage.setItem(
            "dealer_order_varification_mobile",
            result.data.result[0].dealer_order_varification_mobile,
          );
          localStorage.setItem(
            "dealer_login_mobile",
            result.data.result[0].dealer_login_mobile,
          );
          localStorage.setItem(
            "dealer_email",
            result.data.result[0].dealer_email,
          );
          localStorage.setItem(
            "dealer_address",
            result.data.result[0].dealer_address,
          );
          localStorage.setItem(
            "dealer_pincode",
            result.data.result[0].dealer_pincode,
          );
          localStorage.setItem(
            "dealer_pan_number",
            result.data.result[0].dealer_pan_number,
          );
          localStorage.setItem(
            "dealer_gst_number",
            result.data.result[0].dealer_gst_number,
          );
          localStorage.setItem("city_name", result.data.result[0].city_name);
          localStorage.setItem(
            "app_cache_clear",
            result.data.result[0].app_cache_clear,
          );
          localStorage.setItem(
            "order_count",
            result.data.result[0].order_count,
          );
          localStorage.setItem(
            "dealer_price_set",
            result.data.result[0].dealer_price_set,
          );
        }
      });
  };

  const get_orderds = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("from", from);
      formData.append("to", to);
      const res = await axios.post(`${server_url}order_list.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // saveBanners(res.data.result); // Save to IndexedDB
      if (res.data.status === "1") {
        setOrderds(res.data.result);
      } else {
        setOrderds([]);
        // toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  return (
    <>
      <Header />
      <div
        className="page-wrapper"
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          position: "relative",
          backgroundColor: "#ffffff",
        }}
      >
        <div
          className="page-content"
          style={{
            flex: "1 0 auto",
            width: "100%",
            paddingBottom: "env(safe-area-inset-bottom)",
          }}
        >
          <div
            className={
              (isMobile ? "header " : "header ") +
              "aa fixed left-0 w-full shadow-md z-50"
            }
            style={{
              top: "60px",
              padding: "5px",
              backgroundColor: "#f4f1f1",
            }}
          >
            <table
              style={{
                width: "90%",
                backgroundColor: "#f4f1f1",
                margin: "0px 20px 0px 20px",
              }}
            >
              <tbody>
                <tr>
                  <td>
                    <label
                      htmlFor="form1ac"
                      className="color-highlight text-uppercase font-700 font-10"
                      style={{ color: "#ffffff" }}
                    >
                      From Date
                    </label>
                    <input
                      style={{ borderRadius: "10px" }}
                      onChange={(e) => setFrom(e.target.value)}
                      type="date"
                      className="form-control validate-name"
                      id="form1ac"
                      defaultValue={from}
                    />
                  </td>
                  <td style={{width:"30px"}}></td>
                  <td style={{width:"30px"}}></td>
                  <td style={{width:"30px"}}></td>
                  <td>
                    <label
                      htmlFor="form1ac"
                      className="color-highlight text-uppercase font-700 font-10"
                      style={{ color: "#ffffff" }}
                    >
                      To Date
                    </label>
                    <input
                      style={{ borderRadius: "10px" }}
                      onChange={(e) => setTo(e.target.value)}
                      type="date"
                      className="form-control validate-name"
                      id="form1ac"
                      defaultValue={to}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
          </div>

          <div
            className="content "
            style={{
              minHeight: "calc(100vh - 200px)",
              marginTop: isMobile ? "150px" : "73px",
            }}
          >
            {orderds.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "calc(100vh - 300px)",
                  color: "#000000",
                  textAlign: "center",
                  padding: "20px",
                }}
              >
                <p style={{ fontSize: "18px", marginBottom: "10px" }}>
                  No orders found.
                </p>
                <p style={{ fontSize: "14px", opacity: 0.8, color: "#666666" }}>
                  No orders for the selected date range.
                </p>
              </div>
            ) : (
              orderds.map((orderds) => (
                <Link
                  key={orderds.order_id}
                  title="View Order"
                  to={{
                    pathname: "/OrderDetails/" + orderds.order_id,
                    state: { stateParam: true },
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <div
                    className="card card-style mx-0 mb-3"
                    style={{
                      zIndex: "10",
                      borderRadius:
                        orderds.order_status === "Ready For Dispatched"
                          ? "15px 15px 0px 0px"
                          : "",
                      background: "#ffffff",
                      color: "#000000",
                      border: "1px solid #e5e5e5",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                    }}
                  >
                    <div
                      className="content mb-0"
                      style={{ margin: "10px 10px 10px 10px" }}
                    >
                      <div className="d-flex ">
                        <div
                          className="align-self-center"
                          style={{ width: "100%" }}
                        >
                          <h1
                            className="mb-n2 font-16"
                            style={{ color: "#000000" }}
                          >
                            #{orderds.order_id}
                            <span
                              className="font-18 mb-0"
                              style={{
                                float: "Right",
                                color:
                                  orderds.order_status === "Order Pending"
                                    ? "#c9bc00"
                                    : orderds.order_status === "Order Approved"
                                      ? "#28a745"
                                      : orderds.order_status ===
                                          "Order Dispatched"
                                        ? "#007bff"
                                        : orderds.order_status ===
                                            "Order On Hold"
                                          ? "#FFA500"
                                          : orderds.order_status ===
                                              "Order Rejected"
                                            ? "#dc3545"
                                            : orderds.order_status ===
                                                "Order Cancelled"
                                              ? "#000000"
                                              : orderds.order_status ===
                                                  "In Production"
                                                ? "#17a2b8"
                                                : orderds.order_status ===
                                                    "Ready For Dispatched"
                                                  ? "#6f42c1"
                                                  : "#000000",
                                fontWeight: "600",
                              }}
                            >
                              {orderds.order_status}
                            </span>
                          </h1>
                          {dealer_price_set === "1" && (
                            <>
                              <div
                                className="mb-n1 font-18"
                                style={{ display: "flex", width: "100%" }}
                              >
                                <span
                                  style={{
                                    width: "50%",
                                    color: "#28a745",
                                    fontWeight: "600",
                                  }}
                                >
                                  {orderds.order_final_total_with_gst}
                                </span>
                                <span
                                  className="font-18 mb-0"
                                  style={{
                                    float: "Right",
                                    width: "50%",
                                    color: "#dc3545",
                                    textAlign: "right",
                                    fontWeight: "600",
                                  }}
                                >
                                  {orderds.overdue_in_days &&
                                    "Overdue: " + orderds.overdue_in_days}
                                </span>
                              </div>
                              <h6
                                style={{
                                  fontWeight: "300",
                                  marginBottom: "0px",
                                  color: "#333333",
                                }}
                              >
                                Remaining Amount:{" "}
                                {orderds.order_remaining_amount}
                              </h6>
                            </>
                          )}
                          <p
                            className="font-11"
                            style={
                              dealer_price_set !== "1"
                                ? { marginTop: "10px", color: "#666666" }
                                : { color: "#666666" }
                            }
                          >
                            {orderds.order_status === "Order Dispatched" && (
                              <>Due Date: {orderds.order_due_date}</>
                            )}

                            {orderds.order_status === "Order Pending" ? (
                              ""
                            ) : (
                              <>
                                <p
                                  style={{
                                    lineHeight: "1.5",
                                    margin: "0px",
                                    padding: "0px",
                                    color: "#333333",
                                  }}
                                >
                                  {orderds.order_admin_remark}
                                </p>
                              </>
                            )}

                            <span style={{ float: "right", color: "#666666" }}>
                              {orderds.order_date}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      zIndex: "1",
                      width: "100%",
                      marginTop: "-33px",
                      padding: "20px 0px",
                      marginBottom: "1rem",
                      fontSize: "11px",
                      display: "flex",
                      backgroundColor: "#6f42c1",
                    }}
                    data-menu="menu-reservation"
                    className="btn rounded-m text-uppercase font-700"
                  >
                    <p
                      style={{
                        color: "white",
                        paddingTop: "7px",
                        marginBottom: "-10px",
                        textAlign: "left",
                        width: "150%",
                        marginLeft: "5px",
                        fontWeight: "600",
                      }}
                    >
                      {orderds.total_weight_ton}
                    </p>
                    <p
                      style={{
                        color: "white",
                        paddingTop: "7px",
                        marginBottom: "-10px",
                        textAlign: "right",
                        width: "50%",
                        marginRight: "5px",
                        fontWeight: "600",
                      }}
                    >
                      {orderds.total_box}
                    </p>
                  </div>
                </Link>
              ))
            )}
          </div>

        
        </div>

        {isMobile && <div style={{ height: "70px" }}></div>}

        {/* Footer - Always at bottom */}
        <div
          style={{
            flexShrink: 0,
            width: "100%",
            marginTop: "auto",
          }}
        >
          <Footer />
        </div>
      </div>

       <style jsx>{`
       .card-style{
           border: 1px solid rgb(0, 0, 0) !important;
       }
      `}</style>
    </>
  );
}

export default MyOrderds;
